export default "__VITE_ASSET__BOAp49c___"